import React from 'react'
import { FormGroup, Row, Col, Modal, OverlayTrigger, Tooltip as ReactTooltip } from 'react-bootstrap'
import { Form, EmailBox, TextBox, MaskedBox, CheckBox, UrlBox, CurrencyBox, PasswordBox, Switch } from 'fw/forms'
import { Button, ValidationError, Label } from 'fw/components'
import * as API from 'modules/app/API'
import * as Modals from 'fw/globals/Modals';
import * as FormManager from 'fw/forms/form/FormManager';
import * as Block from 'fw/globals/Block'
import { PhoneBox } from 'areas/shared/controls'
import { TooltipCode } from 'areas/shared/consts';
import * as Notifications from 'fw/globals/Notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Currency } from 'fw/components/formatter/Formatter';
import CompleteRegistrationPopUp from './CompleteRegistrationPopUp';

class Registration extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            error: null,
            termsAndConditions: "",
            termsAndConditionsId: null,
            termsAndConditionsAccepted: false,
            continue: false,
            questionnaire: null,
            tooltips: null,
            previousYear: "",
            priorToPreviousYear: "",
            showModal: false,
            annualSalesTypeList: [],
            userRegistrationId: null,
            confirmedPreQualificationAmount: null,
            merchantId: null,
            paypalClientId: null,
            paypalFormUrl: null,
            form: {
                annualSalesTypeId: null,
                companyName: "",
                companyFEIN: "",
                companyGrossRevenue1Amount: null,
                companyGrossRevenue1Year: "",
                companyGrossRevenue2Amount: null,
                companyGrossRevenue2Year: "",
                companyWebsite: "",
                veteranFirstName: "",
                veteranLastName: "",
                mobilePhone: {
					phoneTypeCode: "MOBILE",
					number: "",
					extension: "",
					countryCode: "+1"
				},
                veteranEmail: "",
                login: "",
                password: "",
                questionnaire: null,
            },
            fieldStatus: {
                companyNameOk: null,
                companyFEINOk: null,
                companyGrossRevenue1AmountOk: null,
                companyGrossRevenue2AmountOk: null,
                companyWebsiteOk: null,
                veteranFirstNameOk: null,
                veteranLastNameOk: null,
                mobilePhoneOk: null,
                veteranEmailOk: null,
                loginOk: null,
                passwordOk: null,
                confirmPasswordOk: null
            }
        }
    }

    onCheck = () => {
        this.setState((prevState) => { 
            return { 
                continue: !prevState.continue
            }; 
        });
    }

    agreeTAC = () => {
        this.setState((prevState) => { 
            return { 
                termsAndConditionsAccepted: !prevState.termsAndConditionsAccepted
            }; 
        });
        
        Notifications.success("Terms & Conditions Accepted");

        setTimeout(() => {
            window.scrollTo({
                behavior: "smooth",
                top: this._formTop.offsetTop
            });
            this.companyName.focus();
        }, 200);
    }

    cancel = () => {
        window.location.href = "/public/login";
    }

    validatePasswords() {
        const form = this.state.form;

        if (form.password && form.password !== form.confirmPassword) {
            Notifications.error("The password and confirmation password do not match.");
            return false;
        }

        return true;
    }

    validateQuestionnaire = () => {
        let questionnaire = this.state.questionnaire;
        let validate = true;

        loops:
        for (let i = 0; i < questionnaire.questionCategories.length; i++) {
            let category = questionnaire.questionCategories[i];
            
            let servedInCombatQuestion = category.questions
                .filter(x => (x.code === "RQ2"));
            let servedInCombat = servedInCombatQuestion.length === 1 && servedInCombatQuestion[0].answer;

            for (let j = 0; j < category.questions.length; j++) {
                let question = category.questions[j];
                if ((question.code !== "RQ1" || !servedInCombat) && question.expectedAnswer !== null && question.answer !== question.expectedAnswer) {
                    validate = false;
                    this.setState((prevState) => { 
                        return { 
                            showModal: true, 
                            question: question.text
                        }; 
                    });
                    break loops;
                }
            }
        }

        return validate;
    }

    showCompleteRegistrationPopUp = (userRegistrationId, preQualificationAmount, merchantId, paypalFormUrl, paypalClientId) => {
        this.setState((prevState) => { 
            return { 
                showCompleteRegistrationPopUp: true,
                userRegistrationId: userRegistrationId,
                confirmedPreQualificationAmount: preQualificationAmount,
                merchantId: merchantId,
                paypalFormUrl: paypalFormUrl,
                paypalClientId: paypalClientId
            }; 
        });
    }

    register = (e) => {
        if (!this.validatePasswords())
            return;
        
        if (!this.validateQuestionnaire())
            return;

        const me = this;

        const rq = {
            annualSalesTypeId: this.state.form.annualSalesTypeId,
            companyName: this.state.form.companyName,
            companyFEIN: this.state.form.companyFEIN,
            companyGrossRevenue1Amount: this.getRevenueNumber(this.state.form.companyGrossRevenue1Amount),
            companyGrossRevenue1Year: this.state.previousYear,
            companyGrossRevenue2Amount: this.getRevenueNumber(this.state.form.companyGrossRevenue2Amount),
            companyGrossRevenue2Year: this.state.priorToPreviousYear,
            companyWebsite: this.state.form.companyWebsite,
            veteranFirstName: this.state.form.veteranFirstName,
            veteranLastName: this.state.form.veteranLastName,
            login: this.state.form.login,
            mobilePhone: this.state.form.mobilePhone,
            password: this.state.form.password,
            confirmPassword: this.state.form.confirmPassword,
            veteranEmail: this.state.form.veteranEmail,
            questionnaire: this.state.questionnaire
        }

        // Spinner
        this.setState((prevState) => { 
            return { 
                error: null
            }; 
        });

        API.Security.post('/registration/register', rq,
            {
                success: (sr) => {
                    // Open successful creation pop-up
                    me.showCompleteRegistrationPopUp(sr.data.userRegistrationId, sr.data.preQualificationAmount, sr.data.merchantId, sr.data.paypalFormUrl, sr.data.paypalClientId);
                },
                error: (sr) => {
                    if (sr.error.errorCode === "ExistingEmail" || sr.error.errorCode === "ExistingFein" || sr.error.errorCode === "ExistingCompanyName")
                        Modals.alert(sr.error.errorMessage);
                    else {
                        // For other errors show error message in standard way
                        Notifications.error(sr.error.errorMessage);
                    }
                },
                exception: (err) => {
                    this.setState((prevState) => { 
                        return { 
                            error: { errorMessage: "Oops! Something went wrong. Please contact administrator." }
                        }; 
                    });
                }
            });
    }

    checkFieldStatus = () => { 
        let form = this.state.form;
        
        let companyNameOk = null;
        if (form.companyName.length >= 2)
            companyNameOk = true;
        else if (form.companyName.length > 0)
            companyNameOk = false;
        
        let companyFEINOk = null;
        if (form.companyFEIN.length === 10)
            companyFEINOk = true;
        else if (form.companyFEIN.length > 0)
            companyFEINOk = false;

        let companyGrossRevenue1AmountOk = null;
        let revenue = this.getRevenueNumber(form.companyGrossRevenue1Amount);
        if (revenue && revenue >= 1)
            companyGrossRevenue1AmountOk = true;
        else if (revenue &&revenue < 1)
            companyGrossRevenue1AmountOk = false;

        let companyGrossRevenue2AmountOk = null;
        let revenue2 = this.getRevenueNumber(form.companyGrossRevenue2Amount);
        if (revenue2 && revenue2 >= 1)
            companyGrossRevenue2AmountOk = true;
        else if (revenue2 && revenue2 < 1)
            companyGrossRevenue2AmountOk = false;

        let companyWebsiteOk = null;
        if (form.companyWebsite && form.companyWebsite.length > 0 && this._companyWebsite.validate() === null)
            companyWebsiteOk = true;
        else if (form.companyWebsite && form.companyWebsite.length > 0 && !this._companyWebsite.validate() !== null)
            companyWebsiteOk = false;

        let veteranFirstNameOk = null;
        if (form.veteranFirstName.length >= 2 && form.veteranFirstName.length <= 30)
            veteranFirstNameOk = true;
        else if (form.veteranFirstName.length > 0 && (form.veteranFirstName.length < 2 || form.veteranFirstName.length > 30))
            veteranFirstNameOk = false;

        let veteranLastNameOk = null;
        if (form.veteranLastName.length >= 2 && form.veteranLastName.length <= 30)
            veteranLastNameOk = true;
        else if (form.veteranLastName.length > 0 && (form.veteranLastName.length < 2 || form.veteranLastName.length > 30))
            veteranLastNameOk = false;

        let mobilePhoneOk = null;
		if (form.mobilePhone && form.mobilePhone.countryCode === '+1') {
			if (form.mobilePhone.number && form.mobilePhone.number.length === 14)
            	mobilePhoneOk = true;
        	else if (form.mobilePhone.number && form.mobilePhone.number.length !== 14)
            	mobilePhoneOk = false;
		}
		else {
			if (form.mobilePhone && form.mobilePhone.number)
				mobilePhoneOk = true;
			else if (form.mobilePhone && !form.mobilePhone.number)
				mobilePhoneOk = false;
		}

        let veteranEmailOk = null;
        if (form.veteranEmail && form.veteranEmail.length > 0 && this._veteranEmail.validate() === null)
            veteranEmailOk = true;
        else if (form.veteranEmail && form.veteranEmail.length > 0 && !this._veteranEmail.validate() !== null)
            veteranEmailOk = false;

        // Login format: between 8 and 20 characters, without spaces. 
        // It can contain letters, numbers and special chars including: !@#$%&*()._-+=");
        let loginOk = null;
        let loginPattern = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz01234567890!@#$%&*()._-+=";
        if (form.login && form.login.length >= 8 && form.login.length <= 20 && form.login.split('').every(x => { return loginPattern.includes(x) }))
            loginOk = true;
        else if (form.login && (form.login.length < 8 || form.login.length > 20 || form.login.split('').some(x => { return !loginPattern.includes(x) })))
            loginOk = false;
        
        let passwordOk = null;
        if (form.password && form.password.length > 0 && this._password.validate() === null)
            passwordOk = true;
        else if (form.password && form.password.length > 0 && !this._password.validate() !== null)
            passwordOk = false;

        let confirmPasswordOk = null;
        if (passwordOk === true && form.password && form.confirmPassword && form.password === form.confirmPassword)
            confirmPasswordOk = true;
        else if (passwordOk === true && form.password && form.confirmPassword && form.password !== form.confirmPassword)
            confirmPasswordOk = false;

        let fieldStatus = {
            companyNameOk: companyNameOk,
            companyFEINOk: companyFEINOk,
            companyGrossRevenue1AmountOk: companyGrossRevenue1AmountOk,
            companyGrossRevenue2AmountOk: companyGrossRevenue2AmountOk,
            companyWebsiteOk: companyWebsiteOk,
            veteranFirstNameOk: veteranFirstNameOk,
            veteranLastNameOk: veteranLastNameOk,
            mobilePhoneOk: mobilePhoneOk,
            veteranEmailOk: veteranEmailOk,
            loginOk: loginOk,
            passwordOk: passwordOk,
            confirmPasswordOk: confirmPasswordOk
        };

        this.setState((prevState) => { 
            return { 
                fieldStatus: fieldStatus
            }; 
        });
    }

    getSalesTypeId(revenue) {
        if (!this.state.form || !this.state.form.companyGrossRevenue1Amount)
            return null;

        let annualSalesTypeList = this.state.annualSalesTypeList;
        
        let matchingItems = annualSalesTypeList
            .filter(x => (x.grossRevenueLowerBound === null || x.grossRevenueLowerBound <= revenue) && 
                         (x.grossRevenueUpperBound === null || x.grossRevenueUpperBound >= revenue));

        if (matchingItems.length !== 1)
            return null;
        else
            return matchingItems[0].annualSalesTypeId;
    }

    getRevenueNumber(v) {
        let revenue = `${v !== null ? v : ""}`;

        // Replace every $ character generated from CurrencyBox
        revenue = revenue
            .replace(/\$/g, '');

        // Replace every comma character generated from CurrencyBox
        revenue = revenue
            .replace(/,/g, '');
        
        // Discard everything efter . character (later discarded at CurrencyBox)
        let n = revenue.indexOf('.');
        revenue = revenue
            .substring(0, n !== -1 ? n : revenue.length);

        return revenue;
    }

    onChange = (form) => {
        form.companyWebsite = form.companyWebsite.trim();
        form.veteranEmail = form.veteranEmail.trim();

        let revenue = this.getRevenueNumber(form.companyGrossRevenue1Amount);
        form.companyGrossRevenue1Amount = revenue;

        let revenue2 = this.getRevenueNumber(form.companyGrossRevenue2Amount);
        form.companyGrossRevenue2Amount = revenue2;

        this.setState({ form });
    }

    onCancel = () => {
        const me = this;

        FormManager.checkUnsavedChanges(function () {
            me.cancel();
        })
    }

    componentDidMount() {
        // Get Register Info
        API.Security.get('/registration/getRegisterInfo', null,
        {
            success: (sr) => {
                this.setState((prevState) => { 
                    return { 
                        termsAndConditions: sr.data.termsAndConditionsContent,
                        termsAndConditionsId: sr.data.termsAndConditionsId,
                        questionnaire: sr.data.questionnaire,
                        tooltips: sr.data.tooltips,
                        previousYear: sr.data.previousYear,
                        priorToPreviousYear: sr.data.priorToPreviousYear,
                        annualSalesTypeList: sr.data.annualSalesTypeList
                    }; 
                });
            },
            exception: (sr) => {
                console.error("Error reading Basic Register Info.", sr);
            }
        },
        {
            block: false
        });
    }

    handleAnswerChange = (v, i, j) => {
        let questionnaire = this.state.questionnaire;

        questionnaire.questionCategories[i].questions[j].answer = v;

        this.setState({ ...this.state, questionnaire })

        let question = questionnaire.questionCategories[i].questions[j];

        let servedInCombatQuestion = questionnaire.questionCategories[i].questions
            .filter(x => (x.code === "RQ2"));
        let servedInCombat = servedInCombatQuestion.length === 1 && servedInCombatQuestion[0].answer;

        if ((question.code !== "RQ1" || !servedInCombat) && question.expectedAnswer !== null && question.answer !== question.expectedAnswer) {
            this.setState({ showModal: true, question: question.text })
        }
    }

    renderModal = () => {
        return (
            <Modal
                show={this.state.showModal}>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Ineligibility Alert
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p> Your answer to <strong>{this.state.question} question</strong> makes you ineligible at this time. </p>
                    <p> <strong>Select No -</strong> To return to the prequalification questions. </p>
                    <p> <strong>Select Yes -</strong> To terminate this application. </p>
                    <p> For assistance call (888) 237 - 8434 or (586) 983 - 9955 </p>
                    <p> <strong>** No Refunds Beyond This Point **</strong> </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="btnCancelModal" bsStyle="success" onClick={this.cancel}>Yes</Button>
                    <Button id="btnCloseModal" onClick={this.closeModal}>No</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    closeModal = () => {
        this.setState((prevState) => { 
            return { 
                showModal: false, question: ''
            }; 
        });
    }

    setTip = (property) => {
        const tooltip = this.state.tooltips ? this.state.tooltips.find(t => t.code === property) : undefined
        return tooltip !== undefined ? tooltip.tip : null
    }

    renderQuestionnaire = () => {

        let questionnaire = this.state.questionnaire

        return (
            <React.Fragment>
                {questionnaire &&
                    <React.Fragment>
                        {questionnaire.questionCategories.map((category, i) =>
                            <React.Fragment key={"category" + i}>
                                {category.questions.map((question, j) =>
                                    <Row key={"question" + j}>
                                        <Col xs={9} sm={9} md={9}>
                                            <Label tip={this.setTip(question.code)}>{question.text}</Label>
                                        </Col>
                                        <Col xs={3} sm={3} md={3}>
                                            <FormGroup className="pull-right">
                                                <Switch value={question.answer} onChange={(v) => this.handleAnswerChange(v, i, j)} labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                )}
                            </React.Fragment>

                        )}
                    </React.Fragment>

                }
            </React.Fragment>
        );
    }

    handleCompanyGrossRevenue1AmountChange = (v) => {
        this.checkFieldStatus();

        if (!this.state.form || !this.state.form.companyGrossRevenue1Amount)
        {
            this._annualSalesTypeId.setValue(null);
            return;
        }

        let revenue = this.getRevenueNumber(this.state.form.companyGrossRevenue1Amount);
        let salesTypeId = this.getSalesTypeId(revenue);
        
        this._annualSalesTypeId.setValue(salesTypeId);
    }

    renderFee() {
        let annualSalesTypeList = this.state.annualSalesTypeList;

        if (this.state.form && this.state.form.annualSalesTypeId)
        {
            let matchingItem = annualSalesTypeList.filter(x => x.annualSalesTypeId === this.state.form.annualSalesTypeId);
            if (matchingItem.length === 1)
            {
                let annualSalesTypeDescription = matchingItem[0].description;
                let preQualificationAmount = matchingItem[0].preQualificationAmount;
                
                return(
                    <React.Fragment>
                        <Row>
                            <Col sm={12}>
                                <h3 style={{ color: '#5592b6' }}>Application Fee</h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Sales</th>
                                            <th className="text-right">USD</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <b>{annualSalesTypeDescription}</b>
                                            </td>
                                            <td className="text-right">
                                                <b>
                                                    <Currency value={preQualificationAmount}></Currency>
                                                </b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </React.Fragment>
                );
            }
        }        
    }

    renderFieldStatus(statusOk, invalidTooltipText) {
        let invalidTitle = "Invalid Input";

        if (invalidTooltipText) {
			invalidTitle = invalidTooltipText;
		}

        if (statusOk === true)
        {
            return (
                <FontAwesomeIcon style={{ marginTop: 25, color: "#00a65a" }} icon={faCheck} size="2x" />
            );
        }
        else if (statusOk === false)
        {
            return (
                <React.Fragment>
                    &nbsp;&nbsp;
                    <OverlayTrigger
                        placement="top"
                        rootClose={true}
                        overlay={
                            <ReactTooltip id='tooltip' className="errorTooltipIcon">
                                <div dangerouslySetInnerHTML={{ __html: invalidTitle }} />
                            </ReactTooltip>
                        }>
                        <FontAwesomeIcon style={{ marginTop: 35, color: "#FF0000" }} icon={faTimes} />
                    </OverlayTrigger>
                </React.Fragment>
            );
        }
        else
            return null;
    }

    render() {
        const invalidNameTooltip = "Please enter at least 2 chars.";
        const invalidFeinTooltip = "Invalid FEIN / EIN.";
        const invalidAmountTooltip = "Amount must be greater than $0.";
        const invalidUrlTooltip = "Invalid Url.";
        const invalidLoginTooltip = "Login ID must have between 8 and 20 characters, without spaces. It can contain letters, numbers and special chars including: !@#$%&*()._-+="
        const invalidPhoneTooltip = "Invalid Phone.";
        const invalidPasswordTooltip = "Your password must contain:<ul><li>Between 8 and 256 characters.</li><li>At least one numeric value.</li><li>At least one alphabetic character capitalized.</li><li>At least one special character. The allowable special characters include: !@#$%&*()_-+=</li></ul>";
        const invalidConfirmPasswordTooltip = "The password and confirmation password do not match.";
        const invalidEmailTooltip = "Invalid email address.";

        let fieldStatus = this.state.fieldStatus;
        return (
            <React.Fragment>
                {this.renderModal()}
                <CompleteRegistrationPopUp
                    style={{marginTop:"-55px"}}
                    visible={this.state.showCompleteRegistrationPopUp}
                    userRegistrationId={this.state.userRegistrationId}
                    preQualificationAmount={this.state.confirmedPreQualificationAmount}
                    merchantId={this.state.merchantId}
                    paypalFormUrl={this.state.paypalFormUrl}
                    paypalClientId={this.state.paypalClientId}
                    mobilePhone={this.state.form.mobilePhone}
                    veteranEmail={this.state.form.veteranEmail}
                    companyFEIN={this.state.form.companyFEIN}
                    password={this.state.form.password}
                />
                <div ref={(c) => { this._formTop = c }}></div>
                <ValidationError error={this.state.error} />
                <Block.Block ref={Block.hookref}>
                    {!this.state.termsAndConditionsAccepted ?
                        <React.Fragment>
                            {this.state.termsAndConditions ?
                                <React.Fragment>
                                    <Row>
                                        <Col md={12}>
                                            <div dangerouslySetInnerHTML={{ __html: this.state.termsAndConditions }} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <hr />
                                            <h4 style={{ paddingLeft:25 }}>
                                                <b>
                                                    <CheckBox onChange={this.onCheck} label='I understand and accept that if I fail to comply with the rules and regulations, and, or compliance with the submittal dates, I will NOT RECEIVE A REFUND' value={this.state.continue} />
                                                </b>
                                            </h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12} className="text-right">
                                            <Button type="button" id="btnAgreeTAC" disabled={!this.state.continue} title="Save" bsStyle="primary"
                                                onClick={() => this.agreeTAC()}>
                                                I Agree
                                            </Button>
                                        </Col>
                                    </Row>
                                </React.Fragment>
                            : 
                                <div className="text-center">
                                    <h4>Loading Terms & Conditions, please wait...</h4>
                                    <img src="/images/loading.gif" alt="Please wait..." />
                                </div>
                            }
                        </React.Fragment>
                    :
                        <React.Fragment>
                            <Form
                                onSubmit={this.register}
                                values={this.state.form}
                                onChange={this.onChange}
                                unsavedChangesWarning={true}>
                                <TextBox className="hidden" name="annualSalesTypeId" ref={(c) => { this._annualSalesTypeId = c }} />
                                <Row>
                                    <Col md={12} lg={1}></Col>
                                    <Col md={12} lg={10}>
                                        <Row>
                                            <Col sm={12}>
                                                <h3 style={{ color: '#5592b6' }}>Company Information</h3>
                                                <hr />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                <FormGroup>
                                                    <Label htmlFor="companyName" tip={this.setTip(TooltipCode.REGISTRATION.COMPANY_NAME)} required>Company Name</Label>
                                                    <TextBox required 
                                                        name="companyName" 
                                                        placeholder="Enter your Company Name" 
                                                        maxLength={128}
                                                        onBlur={this.checkFieldStatus}
                                                        ref={(c) => { this.companyName = c }} />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                { this.renderFieldStatus(fieldStatus.companyNameOk, invalidNameTooltip) }
                                            </Col>
                                            <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                <FormGroup>
                                                    <Label htmlFor="companyFEIN" tip={this.setTip(TooltipCode.REGISTRATION.COMPANY_FEIN)} required>FEIN / EIN</Label>
                                                    <MaskedBox required 
                                                        name="companyFEIN"
                                                        placeholder="Enter your FEIN / EIN"
                                                        mask="99-9999999"
                                                        alwaysShowMask={false}
                                                        maskChar=""
                                                        onBlur={this.checkFieldStatus}
                                                        ref={(c) => { this.companyFEIN = c; }} />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                { this.renderFieldStatus(fieldStatus.companyFEINOk, invalidFeinTooltip) }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                <FormGroup>
                                                    <Label htmlFor="companyGrossRevenue1Amount" tip={this.setTip(TooltipCode.REGISTRATION.COMPANY_PREVIOUS_YEAR_AMOUNT)} required>{this.state.previousYear} Gross Revenue Amount</Label>
                                                    <CurrencyBox
                                                        required 
                                                        name="companyGrossRevenue1Amount"
                                                        positiveNumbersOnly
                                                        placeholder='Enter the Revenue Amount'
                                                        maxLength={15}
                                                        precision={0}
                                                        onBlur={(v) => this.handleCompanyGrossRevenue1AmountChange(v)}
                                                        ref={(c) => { this._companyGrossRevenue1Amount = c; }} />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                { this.renderFieldStatus(fieldStatus.companyGrossRevenue1AmountOk, invalidAmountTooltip) }
                                            </Col>
                                            <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                <FormGroup>
                                                    <Label htmlFor="companyGrossRevenue2Amount" tip={this.setTip(TooltipCode.REGISTRATION.COMPANY_PRIOR_TO_PREVIOUS_YEAR_AMOUNT)} required>{this.state.priorToPreviousYear} Gross Revenue Amount</Label>
                                                    <CurrencyBox
                                                        required 
                                                        name="companyGrossRevenue2Amount"
                                                        positiveNumbersOnly
                                                        placeholder='Enter the Revenue Amount'
                                                        maxLength={15}
                                                        precision={0}
                                                        onBlur={this.checkFieldStatus} />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                { this.renderFieldStatus(fieldStatus.companyGrossRevenue2AmountOk, invalidAmountTooltip) }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={11} md={11} lg={11} style={{ paddingRight: 0 }}>
                                                <FormGroup>
                                                    <Label htmlFor="companyWebsite" tip={this.setTip(TooltipCode.REGISTRATION.COMPANY_WEBSITE)}>Company Website</Label>
                                                    <UrlBox
                                                        name='companyWebsite'
                                                        placeholder='Enter your Company Website'
                                                        maxLength={200}
                                                        onBlur={this.checkFieldStatus} 
                                                        clickable={false}
                                                        ref={(c) => { this._companyWebsite = c; }} 
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                { this.renderFieldStatus(fieldStatus.companyWebsiteOk, invalidUrlTooltip) }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={12}>
                                                <br />
                                                <h3 style={{ color: '#5592b6' }}>Veteran Information</h3>
                                                <hr />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                <FormGroup>
                                                    <Label htmlFor="veteranFirstName" tip={this.setTip(TooltipCode.REGISTRATION.VETERAN_FIRST_NAME)} required>Veteran First Name</Label>
                                                    <TextBox required 
                                                        name="veteranFirstName"
                                                        placeholder="Enter your First Name"
                                                        onBlur={this.checkFieldStatus} 
                                                        ref={(c) => { this.firstName = c; }} />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                { this.renderFieldStatus(fieldStatus.veteranFirstNameOk, invalidNameTooltip) }
                                            </Col>
                                            <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                <FormGroup>
                                                    <Label htmlFor="veteranLastName" tip={this.setTip(TooltipCode.REGISTRATION.VETERAN_LAST_NAME)} required>Veteran Last Name</Label>
                                                    <TextBox required
                                                        name="veteranLastName"
                                                        placeholder="Enter your Last Name"
                                                        onBlur={this.checkFieldStatus} 
                                                        ref={(c) => { this.lastName = c; }} />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                { this.renderFieldStatus(fieldStatus.veteranLastNameOk, invalidNameTooltip) }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                <FormGroup>
                                                    <Label htmlFor="login" tip={this.setTip(TooltipCode.REGISTRATION.VETERAN_LOGIN_ID)} required>Login ID</Label>
                                                    <TextBox required 
                                                        name="login"
                                                        onBlur={this.checkFieldStatus} />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                { this.renderFieldStatus(fieldStatus.loginOk, invalidLoginTooltip) }
                                            </Col>
                                            <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                <FormGroup>
                                                    <Label htmlFor="mobilePhone" tip={this.setTip(TooltipCode.REGISTRATION.VETERAN_CELL_PHONE)} required>Cell Phone</Label>
                                                    <div className="form-inline">
														<PhoneBox
															required 
															name="mobilePhone" 
															placeholder="Enter your Cell Phone"
															types={["Mobile"]}
															onBlur={this.checkFieldStatus}
															ref={(c) => { this._mobilePhone = c; }} />
													</div>
                                                </FormGroup>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                { this.renderFieldStatus(fieldStatus.mobilePhoneOk, invalidPhoneTooltip) }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                <FormGroup>
                                                    <Label htmlFor="password" tip={this.setTip(TooltipCode.REGISTRATION.PASSWORD)} required>Password</Label>
                                                    <PasswordBox required
                                                        placeholder="Enter your Password" 
                                                        name="password"
                                                        onBlur={this.checkFieldStatus}
                                                        ref={(c) => { this._password = c; }} />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                { this.renderFieldStatus(fieldStatus.passwordOk, invalidPasswordTooltip) }
                                            </Col>
                                            <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                <FormGroup>
                                                    <Label htmlFor="confirmPassword" tip={this.setTip(TooltipCode.REGISTRATION.CONFIRM_PASSWORD)} required>Confirm Password</Label>
                                                    <PasswordBox required
                                                        placeholder="Confirm your Password"                                                        
                                                        name="confirmPassword"
                                                        onBlur={this.checkFieldStatus} />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                { this.renderFieldStatus(fieldStatus.confirmPasswordOk, invalidConfirmPasswordTooltip) }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={11} md={11} lg={11} style={{ paddingRight: 0 }}>
                                                <FormGroup>
                                                    <Label htmlFor="veteranEmail" tip={this.setTip(TooltipCode.REGISTRATION.VETERAN_EMAIL)} required>Veteran Email Address</Label>
                                                    <EmailBox required 
                                                        name="veteranEmail"
                                                        placeholder="Enter your Veteran Email Address"
                                                        onBlur={this.checkFieldStatus}
                                                        ref={(c) => { this._veteranEmail = c; }} />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                { this.renderFieldStatus(fieldStatus.veteranEmailOk, invalidEmailTooltip) }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <br />
                                                {this.renderQuestionnaire()}
                                            </Col>
                                        </Row>
                                        {this.renderFee()}
                                    </Col>
                                </Row>
                                <br />
                                <hr />
                                <Row>
                                    <Col sm={12} className="text-right">
                                        <Button id="btnCreateAccount" type="submit" bsStyle="primary">Finish Registration</Button>
                                        &nbsp;&nbsp;
                                        <Button id="btnCancel" bsStyle="default" onClick={this.onCancel}>Cancel</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </React.Fragment>
                    }
                </Block.Block>
            </React.Fragment>
        );
    }
}

export default Registration;



// WEBPACK FOOTER //
// ./src/areas/public/registration/Registration.js